import '../elitePlansTheme.css'
import {
  ELITE_PLANS_ELITE_PRIME_TAB_ID,
  ElitePlansLandingProvider,
  useElitePlansLanding
} from '../ElitePlansLandingContext'
import { ElitePlansAnalyticsScreen } from '../constants/analyticsEvents'
import { ELITE_PRIME_DASHBOARD_STATUS_QUERY_KEY } from '../constants/queryKeys'
import { ELITE_PRIME_DASHBOARD_FEATURES_ELITE_BUNDLE_LABEL } from '../constants/copy'
import { ElitePlansPageShell } from '../components/ElitePlansPageShell'
import { ElitePrimeDashboardHeader } from '../components/ElitePrimeDashboardHeader'
import { ElitePrimeDashboardHero } from '../components/ElitePrimeDashboardHero'
import { ElitePlansDashboardBelowFold } from '../components/ElitePlansDashboardBelowFold'
import { useTrackElitePlansScreenLoadWhenReady } from '../hooks/useTrackElitePlansScreenLoadWhenReady'

export default function ElitePrimeDashboardPage() {
  return (
    <ElitePlansLandingProvider
      analyticsScreen={ElitePlansAnalyticsScreen.PrimeDashboard}
      lockedPlanId={ELITE_PLANS_ELITE_PRIME_TAB_ID}
      statusQueryKeyRoot={ELITE_PRIME_DASHBOARD_STATUS_QUERY_KEY}
    >
      <ElitePrimeDashboardPageContent />
    </ElitePlansLandingProvider>
  )
}

function ElitePrimeDashboardPageContent() {
  const { isStatusLoading } = useElitePlansLanding()
  useTrackElitePlansScreenLoadWhenReady(!isStatusLoading)

  return (
    <ElitePlansPageShell>
      <ElitePrimeDashboardHeader />
      <ElitePrimeDashboardHero />
      <ElitePlansDashboardBelowFold
        isContentLoading={isStatusLoading}
        eliteBundleLabel={ELITE_PRIME_DASHBOARD_FEATURES_ELITE_BUNDLE_LABEL}
      />
    </ElitePlansPageShell>
  )
}
